/**
 * Input sanitizers for guest-facing form fields.
 *
 * Applied in onChange handlers so invalid characters can never be typed or
 * pasted in. Backend Pydantic validators enforce the same rules server-side.
 */

/** Keep letters (any language), spaces, hyphens, and apostrophes only. */
export const sanitizeName = (value = "") => value.replace(/[^\p{L}\s'-]/gu, "");
